import type { GoogleMapCoordinates, BingMapCoordinates } from 'ts/types';

export const isGoogleMapCoordinate = (
  coordinate: BingMapCoordinates | GoogleMapCoordinates = {},
): coordinate is GoogleMapCoordinates => {
  if (Object.keys(coordinate).length > 0) {
    return 'lat' in coordinate || 'lng' in coordinate;
  }
  return false;
};

export const isBingMapCoordinate = (
  coordinate: BingMapCoordinates | GoogleMapCoordinates = {},
): coordinate is BingMapCoordinates => {
  if (Object.keys(coordinate).length > 0) {
    return 'latitude' in coordinate || 'longitude' in coordinate;
  }
  return false;
};
